import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';
import {
  addDialogueToFavorites,
  createChatroomDialogue,
  getChatroomDialogues,
  removeDialogueFromFavorites
} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, startLoadingAction} from '../status/actions';
import {
  setChatroomDialogues
} from './actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {
  addDialogueToFavoritesApi,
  createChatroomDialogueApi,
  getChatroomDialoguesApi,
  removeDialogueFromFavoritesApi
} from '../api/chatroom';
import {IChatroomDialogue, INewPost} from './interfaces';

export const loadChatroomDialoguesAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    translation: {locale},
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getChatroomDialogues;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getChatroomDialoguesApi(locale);

      dispatch(finishLoadingAction(actionKey));
      dispatch(setChatroomDialogues(data));
    } catch (e) {
      console.log('loadChatroomDialogues', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadChatroomDialoguesAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const createChatroomDialogueAction = (post: INewPost): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {auth: {auth0Client} } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = createChatroomDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await createChatroomDialogueApi(post);
      dispatch(loadChatroomDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('CreateChatroomDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.CreateChatroomDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const addDialogueToFavoritesAction = (dialogue: IChatroomDialogue): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {auth: {auth0Client} } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = addDialogueToFavorites;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await addDialogueToFavoritesApi(dialogue);
      dispatch(loadChatroomDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('AddDialogueToFavoritesAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.AddDialogueToFavoritesAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const removeDialogueFromFavoritesAction = (dialogue: IChatroomDialogue): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {auth: {auth0Client} } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = removeDialogueFromFavorites;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await removeDialogueFromFavoritesApi(dialogue);
      dispatch(loadChatroomDialoguesAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('RemoveDialogueFromFavoritesAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.RemoveDialogueFromFavoritesAction,
        actionKey,
        error: e
      }));
    }
  }
});
